<rlst-modal header="Select County" class="change-region-modal" (closeModal)="close()" *ngIf="maxNumberCountiesSelection$ | async as maxNumberCountiesSelection">
  <div class="d-flex filters" *ngIf="data.showFilter && !isMarketTrendsOnly">
    <label class="custom-control custom-radio">
      <input type="radio" [formControl]="countyFilterControl" value="ALL" class="custom-control-input radio-primary">
      <span class="custom-control-indicator"></span>
      <span class="custom-control-description">
        <span>All Counties</span>
      </span>
    </label>
    <label class="custom-control custom-radio">
      <input type="radio" [formControl]="countyFilterControl" value="MT" class="custom-control-input radio-primary">
      <span class="custom-control-indicator"></span>
      <span class="custom-control-description">
        <span>Market Trends Only</span>
      </span>
    </label>
    <label class="custom-control custom-radio">
      <input type="radio" [formControl]="countyFilterControl" value="LT" class="custom-control-input radio-primary">
      <span class="custom-control-indicator"></span>
      <span class="custom-control-description">
        <span>Listing Trends Only</span>
      </span>
    </label>
  </div>
  <div class="content" [ngClass]="{'content_no-top-padding': isMobileNextStep}">
    <div class="mobile-back d-md-none d-flex justify-content-between" *ngIf="isMobileNextStep">
      <button class="btn btn-back p-0 w-auto" type="button" (click)="backButtonClickHandler()">
        <i class="fa fa-angle-left" aria-hidden="true"></i>BACK
      </button>
    </div>
    <rlst-categories-list class="mobile-step-host mobile-step-host--states"
                          [ngClass]="isMobileNextStep ? 'mobile-step-host--active' : 'mobile-step-host--inactive'"
                          [categories]="displayedStates"
                          (categorySelection)="selectState($event)"
                          [selectedCategory]="selectedState"
                          [isMobileNextStep]="isMobileNextStep"
                          [aggregateCategoryTitle]="aggregateCategoryTitle"
                          headerTitle="States"></rlst-categories-list>
    <rlst-attributes-selection [attributes]="displayedCounties"
                               [maxNumber]="maxNumberCountiesSelection"
                               [selectedNumber]="selectedRegions.length"
                               [isMobileNextStep]="isMobileNextStep"
                               [highlightProperty]="data.showFilter && !isMarketTrendsOnly && countyFilterControl.value === 'ALL' ? 'isListingTrendCounty' : null"
                               headerTitle="Counties"
                               class="w-100 attributes-selection mobile-step-host mobile-step-host--counties"
                               [ngClass]="isMobileNextStep ? 'mobile-step-host--active' : 'mobile-step-host--inactive'"
                               (attributeIsSelected)="selectAttribute($event)">
    </rlst-attributes-selection>
    <div class="selected-properties mobile-step-host mobile-step-host--selected"
         [ngClass]="isMobileNextStep ? 'mobile-step-host--inactive' : 'mobile-step-host--active'">
      <rlst-selected-properties (closeModal)="close()" headerTitle="Selected Counties"
        [nextStepButtonLabel]="nextStepButtonLabel" class="selected-options" [ngClass]="{ 'd-flex': !isMobileNextStep }"
        [selectedItems]="selectedAttributes" [maxNumber]="maxNumberCountiesSelection"
        (toggleMobileNextStep)="toggleMobileNextStep()" (itemRemoved)="removeRegion($event)"
        (registerChanges)="onSelectionOrderChanged()" (clearSelection)="clearSelection()">
        <ng-template #selectedProperty let-item>
          <div>
            <p class="current-item m-0">
              {{item.countyName}}, {{item.stateCode}}
            </p>
            <p class="sub-label text-overflow m-0">
              Recording Date: {{item.latestRecordingDate | date : 'MM/dd/y' }}
            </p>
          </div>
        </ng-template>
      </rlst-selected-properties>
      <span class="note" *ngIf="data.showFilter && !isMarketTrendsOnly && countyFilterControl.value === 'ALL'">
        *Market Trends Only
      </span>
      <span class="d-flex additional-note" *ngIf="data.showFilter && !isMarketTrendsOnly && isBothCountiesSelected()">
        <i class="far fa-info-circle"></i>
        In some of the selected counties, ListingTrends data is unavailable.  We'll default to displaying Market Trends data only for all selected counties. To view ListingTrends data, please deselect the "MarketTrends Only" counties.
      </span>
    </div>

  </div>
  <div mat-dialog-actions class="actions-panel d-flex">
    <div class="flex-spacer"></div>
    <button (click)="close()" class="btn-custom cancel-button">Cancel</button>
    <button class="btn apply" [disabled]="!selectedRegions.length" (click)="apply()">Apply</button>
  </div>
</rlst-modal>
